import { Button, styled } from '@mui/material'
import PlaceIcon from '@mui/icons-material/Place'

export const CardContainer = styled('div')<{ isSelected: boolean }>(
  ({ theme, isSelected }) => ({
    width: 416,
    borderRadius: 10,
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    boxShadow: '1px 1px 16px grey',
    zIndex: isSelected ? 3 : 0,
    [theme.breakpoints.down(575)]: {
      transform: 'scale(0.8) translate(0px,35px)',
    },
    '& >button': {
      position: 'absolute',
      right: 0,
      top: 0,
      '& >svg': {
        width: 12,
        height: 12,
      },
    },
    '& .bottom-arrow': {
      position: 'absolute',
      left: 0,
      right: 0,
      margin: '0 auto',
      width: 0,
      height: 0,
      borderTop: `25px solid ${theme.palette.common.white}`,
      borderLeft: '50px solid transparent',
      borderRight: '50px solid transparent',
    },
  })
)

export const Body = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  width: 275,
  '& .separator': {
    margin: '0 0.3rem',
  },
  '& a,span': {
    fontSize: 14,
  },
})

export const MainInfo = styled('div')({
  display: 'flex',
  '& >div': {
    width: '100%',
    margin: '1rem 1rem 0 0',
  },
  '& img': {
    width: 120,
    height: 120,
    marginRight: 10,
    borderRadius: '10px 0 0 0',
  },
})

export const DirectionsContainer = styled('div')({
  whiteSpace: 'nowrap',
  '& >svg': {
    marginBottom: -4,
    marginRight: 4,
  },
})

export const BottomContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  padding: '1rem',
  '& >a': {
    textDecoration: 'none',
  },
})

export const BookButton = styled(Button)(({ theme }) => ({
  width: 160,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}))

export const Slots = styled('div')(({ theme }) => ({
  width: 176,
  margin: 'auto 0',
  '& >p:first-of-type': {
    fontSize: '1rem',
    display: 'flex',
    marginBottom: '0.3rem',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[400],
  },
}))

export const SlotOption = styled('div')<{
  available: Number
}>(({ theme, available }) => ({
  fontSize: '1rem',
  display: 'flex',

  margin: '0 auto 0.3rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: available ? theme.palette.primary.main : theme.palette.grey[400],
  '& >div': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '26px',
    height: '26px',
    marginRight: '0.6rem',
    borderRadius: '50%',
    backgroundColor: available
      ? theme.palette.primary.main
      : theme.palette.grey[400],
    '& >svg': {
      fill: theme.palette.common.white,
    },
  },
}))

export const MarkerContainer = styled('div')<{ isSelected: boolean }>(
  ({ isSelected }) => ({
    margin: '-258px 0 0 -208px',
    '& >div': {
      position: 'relative',
      width: 'fit-content',
      paddingBottom: 48,
      '& >svg': {
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        cursor: 'pointer',
        zIndex: isSelected ? 1 : 2,
      },
    },
  })
)

export const SPlaceIcon = styled(PlaceIcon)<{ isPediatrics: boolean }>(
  ({ theme, isPediatrics }) => ({
    color: theme.palette.primary[isPediatrics ? 'light' : 'main'],
    ...(isPediatrics
      ? { stroke: theme.palette.primary.main, strokeWidth: 1 }
      : null),
  })
)
